<template>
  <div id="app">
    <div class="header-container">
      <header class="header flx">
        <div class="logo-box flx" @click="reload">
          <img class="logo-img" src="./assets/logo.png"/>
          <div class="logo-title-box">
            <div class="web-title">嘿喵淘客</div>
            <div class="web-site">heytmall.com</div>
          </div>
        </div>
        <div class="nav-box flx">
          <div class="nav-item cur-nav-item">首页</div>
<!--          <div class="nav-item"><a href="//admin.heytmall.com/#/login" target="_blank">注册</a></div>-->
          <div class="nav-item"><a href="//admin.heytmall.com/#/login" target="_blank">登陆</a></div>
        </div>
      </header>
      <div class="nav-img"><img src="./assets/heytmall_bg.jpg"><a target="_blank" class="free-buy" href="https://jq.qq.com/?_wv=1027&k=5UrfE3N" title="点击链接加入群聊【嘿喵淘客软件】">免费获取</a></div>
    </div>
    <div class="introduce-container">
      <div class="introduce-header">功能介绍</div>
      <div class="introduce-list flx">
        <div class="func-item" :key="index" v-for="(item,index) in funcList">
          <img class="func-icon" :src="item.img"/>
          <div class="item-title">{{item.funcTitle}}</div>
          <div class="func-content">{{item.funcContent}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  data(){
    return {
      addQqHref: 'https://jq.qq.com/?_wv=1027&k=5yEpxvU',
      funcList:[
        {
          funcTitle: '店铺转链',
          funcContent: '可对淘宝/天猫店铺进行转链，并生成短链接和淘口令',
          img: require('./assets/icon-2.png')
        },
        {
          funcTitle: '批量转链',
          funcContent: '一次性对多条数据进行转链，轻松实现百条数据一键转链',
          img: require('./assets/icon-1.png')
        },
        {
          funcTitle: 'QQ群发',
          funcContent: '自定义转发内容至任一想发的QQ群',
          img: require('./assets/icon-6.png')
        },
        {
          funcTitle: '微信群发',
          funcContent: '自定义转发内容至任一想发的微信群',
          img: require('./assets/icon-4.png')
        },
        {
          funcTitle: '监听QQ群',
          funcContent: '可采集各种QQ群,可跟发直播/商品/可一次性采集多个QQ群,最强大的Q群采集监听功能',
          img: require('./assets/icon-5.png')
        },
        {
          funcTitle: '群消息自动同步网站',
          funcContent: '自动把QQ群的消息同步到网页上，形成自己个性化的网站',
          img: require('./assets/icon-3.png')
        },
        {
          funcTitle: '挖券神器',
          funcContent: ' 从手机淘宝复制链接到网站中的挖券神器功能区，就能一键挖券',
          img: require('./assets/icon-2.png')
        },
        {
          funcTitle: '淘客代理分佣',
          funcContent: '最多支持三级代理',
          img: require('./assets/icon-1.png')
        },
        {
          funcTitle: '淘客cms网站系统',
          funcContent: '快速搭建专业的导购网站，可自定义网站名称，栏目名称',
          img: require('./assets/icon-6.png')
        },
        {
          funcTitle: '快捷发单系统',
          funcContent: '快捷发单系统 直接把精选数据库的商品，一键发送至群和网站',
          img: require('./assets/icon-4.png')
        },
        {
          funcTitle: '云数据库',
          funcContent: '提供强大的云数据库,每天几万款优惠券商品供您选择',
          img: require('./assets/icon-5.png')
        },
        {
          funcTitle: '手动转链发布',
          funcContent: '拥有手动一键快速转链，转链完成，支持一键发送群和网站',
          img: require('./assets/icon-3.png')
        },
        {
          funcTitle: '淘口令转链',
          funcContent: '可直接对淘口令进行转链，生成自己的淘口令',
          img: require('./assets/icon-2.png')
        },
        {
          funcTitle: '自定义淘口令符号',
          funcContent: '可自定义淘口令符号，防止被微信和谐',
          img: require('./assets/icon-1.png')
        },
        {
          funcTitle: '淘口令解密',
          funcContent: '可把淘口令解析出商品的本来链接',
          img: require('./assets/icon-6.png')
        },
        {
          funcTitle: '二合一还原',
          funcContent: '可对二合一链接还原成商品链接+优惠券链接',
          img: require('./assets/icon-4.png')
        },
        {
          funcTitle: '关键词替换',
          funcContent: '可对一些敏感关键词进行替换或和谐',
          img: require('./assets/icon-5.png')
        },
        {
          funcTitle: '精选优质线报群',
          funcContent: '线报群时时同步当天的漏洞神单和大额券',
          img: require('./assets/icon-3.png')
        }
      ]
    }
  },
  methods:{
    // getImgUrl(index){
    //   return `./assets/icon-${index+1}.png`;
    // },
    freeBuy(){

    },
    // loadImg(src){
    //   return require(src)
    // },
    reload(){
      location.reload();
    }
  },
  mounted() {
    console.log(this.funcList.length);
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
  *{
    padding: 0;
    margin:0;
  }
  body{
    min-width: 1024px;
    color:#000000;
    background: #F8F8F8;
  }

  .header{
    height:75px;
  }
  .logo-img{
    display: block;
    width: 50px;
    height:50px;
  }
  .logo-box{
    margin-left:210px;
    align-items: center;
    cursor: pointer;
  }
  .logo-title-box{
    padding-left: 14px;
  }
  .flx{
    display: flex;
  }
  .clearfix:after{
    content: " ";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .fl{
    float: left;
  }


  .web-title{
    font-size: 18px;
  }
  .web-site{
    font-size: 14px;
  }
  .nav-box{
    margin:20px 0 0 40px;
  }
  .nav-item{
    cursor: pointer;
    padding:0 0 10px 0;
    height:17px;
    margin-left: 52px;
  }
  .nav-item a{
    color: #000000;
    text-decoration: none;
  }
  .cur-nav-item{
    border-bottom: 3px solid #000000;
  }

  .nav-img{
    position: relative;
  }
  .nav-img img{
    width:100%;
  }
  .free-buy{
    background: rgba(255,255,255,0.1);
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    bottom:40px;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    border:1px solid #fff;
    text-align: center;
    padding:4px 28px;
    border-radius: 20px;
  }

  .introduce-header{
    text-align: center;
    font-size: 28px;
    padding:30px 0 12px;
    font-weight: bold;
  }
  .introduce-container{
    width:1018px;
    margin:0 auto;
  }

  .introduce-list{
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
  }
  .func-item{
    position: relative;
    width:302px;
    margin:18px;
    justify-self: center;
    box-sizing: border-box;
    padding:27px 14px 43px;
    background:rgba(255,255,255,1);
    box-shadow:0px 3px 15px 0px rgba(215,215,215,0.3);
    border-radius:15px;
  }

  .func-icon{
    margin:0 auto;
    display: block;
    width:50px;
    height:50px;
  }
  .item-title{
    margin-top:18px;
    font-weight: bold;
    font-size: 18px;
    padding-bottom: 14px;
    text-align: center;
  }
  .func-content{
    line-height: 28px;
    font-size: 14px;
  }

</style>
